import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { getDefaultTransition } from '../../../../utils/getDefaultTransition'

export const DayWrapper = styled.li``

interface DayButtonProps {
  bgColor?: Color
  disabled?: boolean
  selected?: boolean
}

export const DayButton = styled.button<DayButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background-color: ${({ bgColor = Color.White }) => bgColor};
  appearance: none;
  ${getDefaultTransition('background-color')}

  ${({ disabled, selected }) =>
    !selected &&
    !disabled &&
    css`
      cursor: pointer;
    `}
`
